export default __webpack_public_path__ + "static/media/phylactere_ het_leven_NL.c2fc15d9.png";